import { render, staticRenderFns } from "./preItem.vue?vue&type=template&id=7a155fb0&scoped=true&lang=pug&"
import script from "./preItem.vue?vue&type=script&lang=ts&"
export * from "./preItem.vue?vue&type=script&lang=ts&"
import style0 from "./preItem.vue?vue&type=style&index=0&id=7a155fb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a155fb0",
  null
  
)

export default component.exports